<template>
  <div class="content">
    <div class="p">
      <b>At the point of CT install</b> check the rating of the clip on CT for
      each of the connections listed below.
    </div>

    <div class="p">Note the location of the clip on CT rating</div>

    <img src="../../../../../assets/png/ct-rating.png" />

    <div class="p" data-tn="ct-error-list">
      Connection to check:
      <ul class="p">
        <li v-for="(unit, i) in CTReadingIncorrectUnits" :key="i">
          {{ unit }}
        </li>
      </ul>
    </div>

    <back-and-next
      next-text="Next - CT Installation"
      data-tn="ct-reading-incorrect-au/4"
      to="/commission/error/ct-reading-incorrect-au/5"
    >
    </back-and-next>
  </div>
</template>

<script>
import { CommissionErrorMixin } from "../../../../../mixins/commissionError";

export default {
  mixins: [CommissionErrorMixin],
};
</script>

<style scoped lang="less">
.content {
  .p {
    margin-top: 20px;
  }
  img {
    margin-top: 20px;
    width: 100%;
  }
}
</style>
